import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {PuffsEnum} from '../../../enums/PuffsEnum';
import {GaPreffixEnum, NativePuffTypeEnum} from '../../../enums/AdEnums';
import {DLPageTypeEnum} from '../../../enums/DataLayerEnums';
import {StaticSidebarPuffsService} from '../../../services/static-sidebar-puffs.service';

@Component({
  selector: 'app-sidebar-puffs-list',
  templateUrl: './sidebar-puffs-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class SidebarPuffsListComponent {
  public pageType = input<DLPageTypeEnum>(null);

  public puffsEnum = PuffsEnum;
  public nativePuffTypeEnum = NativePuffTypeEnum;
  public gaPreffixEnum = GaPreffixEnum;
  protected readonly DLPageTypeEnum = DLPageTypeEnum;
  private sidebarPuffsService = inject(StaticSidebarPuffsService);
  public puffs = this.sidebarPuffsService.puffs;
}
